var app = app || {};
var BASEURL = "";
var ADMINBASEURL = "";
export {BASEURL, ADMINBASEURL, app}
